import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Modal from '../../../UniformComponents/Modal'
import Input from '../../form/Input'
import InfoAccordion from '../../InfoAccordion'
import Button from '../../../UniformComponents/Button'
import DataTable from '../../DataTable'
import Typography from '../../../UniformComponents/Typography'

@observer
class PreviewModal extends Component {
    getColumns = () => [
        {
            key: 'optout',
            name: 'Optout',
            dataTransform: (value) => (
                [
                    <span className="email-list-status">{value}</span>,
                ]
            ),
        },
        {
            key: 'email',
            name: 'Email',
            dataTransform: (value) => (
                [
                    <span className="email-list-status"><strong>{value}</strong></span>,
                ]
            ),
        },
        {
            key: 'firstname',
            name: 'First name',
            dataTransform: (value) => (
                [
                    <span className="email-list-status">{value}</span>,
                ]
            ),
        },
        {
            key: 'lastname',
            name: 'Last name',
            dataTransform: (value) => (
                [
                    <span className="email-list-status">{value}</span>,
                ]
            ),
        },
        {
            key: 'companyname',
            name: 'Company name',
            dataTransform: (value) => (
                [
                    <span className="email-list-status">{value}</span>,
                ]
            ),
        },
    ]

    getEmailColumns = () => [
        {
            key: 'email',
            name: 'Email',
            dataTransform: (value) => (
                [
                    <span>{value}</span>,
                ]
            ),
        },
    ]

    render() {
        const { distributeStore } = this.props
        const {
            previewModalVisible,
            hidePreviewModal,
            importDetails,
            verifyEmails,
            previewContinue,
            listName,
        } = distributeStore

        const totalRecords = importDetails.numSurveyUsers
        + importDetails.emailDuplicatesInFile.length
        + importDetails.emailDuplicatesInDb.length
        + importDetails.emailsInBlacklist.length

        const totalDupes = importDetails.emailDuplicatesInFile.length
        + importDetails.emailDuplicatesInDb.length

        const dupes = [
            ...importDetails.emailDuplicatesInDb,
            ...importDetails.emailDuplicatesInFile,
        ].map((email) => ({ email }))
        const blacklisted = distributeStore.importDetails.emailsInBlacklist.map((email) => ({ email }))

        return (
            <Modal
                show={previewModalVisible}
                onClose={hidePreviewModal}
                cssClass="x-large"
            >
                <div className="email-list-modal">
                    {distributeStore.importProcessing
                        ? (
                            <div style={{ textAlign: 'center' }}>
                                <Typography type="h4">{i18n.t('distributionEmailList.previewTitle')}</Typography>

                                <Typography type="tiny">{i18n.t('distributionEmailList.uploadingSubText1')}</Typography>

                                <Typography type="tiny">{i18n.t('distributionEmailList.uploadingSubText2')}</Typography>
                            </div>
                        )
                        : (
                            <div>
                                <div>
                                    <h2>
                                        {i18n.t('previewModal.title')}
                                    </h2>

                                    <h4>
                                        {i18n.t('previewModal.subtitle')}
                                    </h4>
                                </div>

                                <br />

                                <Input
                                    label={i18n.t('previewModal.emailListName')}
                                    placeholder={i18n.t('form.input.placeholder')}
                                    onBlur={distributeStore.previewListNameOnChange}
                                    defaultValue={distributeStore.listName}
                                />

                                <br />

                                <InfoAccordion
                                    title={i18n.t('previewModal.uploadedStats')}
                                    show={distributeStore.uploadStatsAccordionOpen}
                                    toggle={distributeStore.toggleUploadStatsAccordion}
                                >
                                    <p>
                                        {i18n.t('sch_upload_statistics_total_records')}
                                        :
                                        {totalRecords}
                                    </p>

                                    <p>
                                        {i18n.t('sch_upload_statistics_duplicate')}
                                        :
                                        {(totalDupes)}
                                    </p>

                                    <p>
                                        {i18n.t('sch_upload_statistics_blacklisted')}
                                        :
                                        {importDetails.emailsInBlacklist.length}
                                    </p>

                                    <p>
                                        {i18n.t(
                                            verifyEmails
                                                ? 'sch_upload_statistics_total_emails_2bimported'
                                                : 'sch_upload_statistics_total_emails_2bimported_no_verify',
                                        )}
                                        :
                                        {importDetails.numSurveyUsers}
                                    </p>
                                </InfoAccordion>

                                <br />

                                <div className="create-user-modal-buttons">
                                    <Button
                                        cssClass="regular tertiary"
                                        onClick={hidePreviewModal}
                                        label={i18n.t('cancel')}
                                    />

                                    <Button
                                        cssClass="regular primary"
                                        onClick={previewContinue}
                                        disabled={!listName.length}
                                        label={i18n.t('previewModal.confirm')}
                                    />
                                </div>

                                <br />

                                {/* <Search ref={s => distributeStore.searchModule = s} onSearch={distributeStore.previewSearch} cssClass="distribute-top-panel-search" /> */}

                                <InfoAccordion
                                    title={`${i18n.t('sch_user_uploadpreview')} ( ${importDetails.numSurveyUsers} )`}
                                    hideInfoIcon
                                    show={distributeStore.previewDataAccordionOpen === 'preview'}
                                    toggle={() => distributeStore.togglePreviewDataAccordion('preview')}
                                    cssClass="preview-modal-data-accordion"
                                >
                                    <DataTable
                                        store={distributeStore}
                                        dataSet={distributeStore.importDetails.surveyUsers}
                                        inMemory
                                        columns={this.getColumns()}
                                        cssClass="data-table-text-left"
                                    />
                                </InfoAccordion>

                                {totalDupes
                                    ? (
                                        <React.Fragment>
                                            <br />

                                            <InfoAccordion
                                                title={`${i18n.t('sch_duplicated_removed')} ( ${importDetails.emailDuplicatesInDb.length + importDetails.emailDuplicatesInFile.length} )`}
                                                hideInfoIcon
                                                show={distributeStore.previewDataAccordionOpen === 'dupe'}
                                                toggle={() => distributeStore.togglePreviewDataAccordion('dupe')}
                                                cssClass="preview-modal-data-accordion"
                                            >
                                                <DataTable
                                                    store={distributeStore}
                                                    dataSet={dupes}
                                                    inMemory
                                                    columns={this.getEmailColumns()}
                                                    cssClass="data-table-text-left"
                                                />
                                            </InfoAccordion>
                                        </React.Fragment>
                                    ) : null}

                                {importDetails.emailsInBlacklist.length
                                    ? (
                                        <React.Fragment>
                                            <br />

                                            <InfoAccordion
                                                title={`${i18n.t('sch_blacklisted_removed')} ( ${importDetails.emailsInBlacklist.length} )`}
                                                hideInfoIcon
                                                show={distributeStore.previewDataAccordionOpen === 'blacklist'}
                                                toggle={() => distributeStore.togglePreviewDataAccordion('blacklist')}
                                                cssClass="preview-modal-data-accordion"
                                            >
                                                <DataTable
                                                    store={distributeStore}
                                                    dataSet={blacklisted}
                                                    inMemory
                                                    columns={this.getEmailColumns()}
                                                    cssClass="data-table-text-left"
                                                />
                                            </InfoAccordion>
                                        </React.Fragment>
                                    ) : null}
                            </div>
                        )}
                </div>
            </Modal>
        )
    }
}

export default PreviewModal
